// 機能横断で使う共通メッセージ
export const INVALID_INPUT = '入力内容が間違っています';
export const DATE_INVALID = '存在しない日付が入力されています。';
// 通信
export const NETWORK_ERROR = '通信エラーが発生しました。通信環境をご確認のうえ、再度実行してください。';
// その他
export const ACCOUNT_EXPIRED = 'ご登録アカウントの有効期限が切れています';
export const INVALID_PLAN_FOR_FRIEND_INVITE = '友達招待ができないプランです';
